import React, { FC } from 'react'
import { Paper } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import format from 'date-fns/format'
import { TableToolbar } from 'src/components/ui'
import { TransferErrorRow } from 'src/components/columns/contractorTransferHelpers'

const columns: GridColDef<TransferErrorRow>[] = [
  {
    field: 'at',
    headerName: 'When',
    minWidth: 190,
    sortable: false,
    valueFormatter: (params) => (params.value ? format(new Date(params.value as string), 'PPpp') : '')
  },
  { field: 'stage', headerName: 'Stage', minWidth: 150, sortable: false },
  { field: 'message', headerName: 'Error', minWidth: 320, flex: 1, sortable: false }
]

interface ContractorTransferErrorsProps {
  rows: TransferErrorRow[]
  exportedFileName: string
}

/** Every failure of the transfer by stage, including the ones a retry recovered from. */
export const ContractorTransferErrors: FC<ContractorTransferErrorsProps> = ({ rows, exportedFileName }) => (
  <Paper sx={{ width: '100%', minWidth: 0 }}>
    <DataGridPremium<TransferErrorRow>
      rows={rows}
      columns={columns}
      autoHeight
      getRowHeight={() => 'auto'}
      disableRowSelectionOnClick
      hideFooter
      slots={{ toolbar: () => <TableToolbar exportedFileName={exportedFileName} /> }}
      sx={{ border: 'none', '& .MuiDataGrid-cell': { py: 1 } }}
    />
  </Paper>
)
